import * as z from "zod";

export const voidShipments = {
  name: "voidShipments" as const,
  input: z
    .object({ fulfillmentGroupIds: z.array(z.string()) })
    .or(z.object({ batchId: z.string() })),
  output: z.object({
    success: z.boolean(),
    unVoidableFulfillmentGroupIds: z.array(z.string()),
  }),
};
